export const QUOTE_STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  processing: { bg: '#fef3c7', text: '#92400e' },
  ready: { bg: 'var(--color-success-50)', text: 'var(--color-success-600)' },
  review: { bg: '#ede9fe', text: '#5b21b6' },
  approved: { bg: '#d1fae5', text: '#065f46' },
  ordered: { bg: 'var(--color-primary-50)', text: 'var(--color-primary-700)' },
  rejected: { bg: '#fee2e2', text: '#991b1b' },
  expired: { bg: 'var(--bg-surface-sunken)', text: 'var(--text-tertiary)' },
};
